<template>
  <li class="fRow jStart aCenter fullWidth transition-fast ali">
    <div class="ind">{{indx + 1}}</div>
    <div class="name">{{data.name}}</div>
    <div class="phone growFull">{{data.mobile.replace('98', '0')}}</div>
    <div class="b fRow jStart aCenter" style="margin: 0 8px 0 0"
      v-if="!excelDataLoaded"
      @click="getExcelData(data.id)">
      <i class="material-icons-round">get_app</i>
      <label>مشاهده کارنامه</label>
    </div>
    <download-excel
      class='b fRow jStart aCenter active'
      :data="excelData"
      type="xls"
      v-if="excelDataLoaded"
      :fields="excelFields"
      worksheet='لیست حساب‌ها'
      :name="`کارنامه‌ ${data.name} - ${examName}.xls`">
      <i class="material-icons-round">get_app</i>
      <label>دانلود فایل اکسل</label>
    </download-excel>
  </li>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'indx', 'examName'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      excelDataLoaded: false,
      excelData: [],
      excelFields: {
        // eslint-disable-next-line
        'نام درس': 'lessonName',
        // eslint-disable-next-line
        'تعداد کل سؤالات': 'total',
        // eslint-disable-next-line
        'پاسخ صحیح': 'tr',
        // eslint-disable-next-line
        'پاسخ اشتباه': 'wr',
        // eslint-disable-next-line
        'بدون پاسخ': 'blank',
        // eslint-disable-next-line
        'درصد': 'percent',
      },
    };
  },
  methods: {
    // دریافت نتایج آزمون
    getExcelData(id) {
      axios({
        method: 'get',
        url: `${this.baseURL}/api/v${this.V}/Results/answersheet/${id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            const r = response.data.data;
            // اینجا باید دیتای خام رو ردیف کنیم و برای اکسل آماده کنیم
            for (let i = 0; i < r.length; i += 1) {
              let p = (r[i].currectScore * 3) - r[i].inCorrectScore;
              p /= (r[i].totalQuestion * 3);
              p *= 100;
              const a = {
                lessonName: r[i].name,
                tr: r[i].currectScore,
                wr: r[i].inCorrectScore,
                blank: r[i].totalQuestion - (r[i].currectScore + r[i].inCorrectScore),
                percent: p.toFixed(2),
                total: r[i].totalQuestion,
              };
              this.excelData.push(a);
            }
            this.excelDataLoaded = true;
          }
        },
        (error) => {
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  li.ali {
    padding: 8px;
    margin: 0;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
    .ind {
      font-size: 10px;
      font-weight: 100;
      width: 32px;
    }
    .name {
      font-size: 14px;
      font-weight: 300;
      color: rgb(53, 53, 53);
      text-align: right;
    }
    .phone {
      font-size: 12px;
      font-weight: 300;
      padding-right: 8px;
      color: rgb(92, 92, 92);
      text-align: right;
    }
    .score {
      font-size: 14px;
      min-width: 64px;
      font-weight: 300;
      padding: 2px 8px;
      border-radius: 24px;
      background-color: rgba($color: #000000, $alpha: 0.15);
      color: rgb(63, 63, 63);
    }
  }
  li:hover {
    background-color: rgba($color: #000000, $alpha: 0.05);
  }
</style>
